module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4nQv5"))).then(() => parcelRequire('8rm4T'));